import { Container } from 'inversify'

import { BeachVolleyballIncidentId } from '@collector/sportsapi-client-legacy'
import { RelationSportCommonIoCBindings } from '@mobile/views/Relation/Shared/RelationSportCommonDependencies/relationSportCommonDependencies'

export function bindIncidentsResultConfiguration(ioc: Container): void {
  ioc
    .bind(RelationSportCommonIoCBindings.IncidentsResultConfiguration)
    .toDynamicValue(() => {
      return {
        scoringIncidents: new Map([
          [BeachVolleyballIncidentId.ServiceAce, { add: 1, visible: true }],
          [BeachVolleyballIncidentId.AttackPoint, { add: 1, visible: true }],
          [BeachVolleyballIncidentId.BlockPoint, { add: 1, visible: true }],
          [BeachVolleyballIncidentId.Point, { add: 1, visible: true }],
          [BeachVolleyballIncidentId.SecondSetStarted, { set: 0 }],
          [BeachVolleyballIncidentId.ThirdSetStarted, { set: 0 }],
        ]),
        oppositeTeamScoringIncidents: new Map([
          [BeachVolleyballIncidentId.ServiceError, { add: 1, visible: true }],
          [BeachVolleyballIncidentId.AttackError, { add: 1, visible: true }],
          [
            BeachVolleyballIncidentId.TechnicalErrors,
            { add: 1, visible: true },
          ],
          [BeachVolleyballIncidentId.RedCard, { add: 1, visible: true }],
          [BeachVolleyballIncidentId.SecondSetStarted, { set: 0 }],
          [BeachVolleyballIncidentId.ThirdSetStarted, { set: 0 }],
        ]),
      }
    })
    .inSingletonScope()
}
